// warehouse/schema.js — el schema completo de la bodega local (F6.4a).
//
// Nombres de columna calcados EXACTOS de los JSON reales de /sync/bundle y
// /sync/state (censo F6.3): F6.4b escribe las respuestas directo a estas
// tablas sin traducir ni un campo.
//
// UN SOLO DUEÑO A LA VEZ: no hay user_id en ninguna tabla. El aislamiento
// entre usuarios se logra borrando físicamente en las fronteras de identidad
// (ver identity.js), no filtrando por columna.
//
// F6.5a (v3): nacen el diario (local_events) y la sesión en vuelo
// (local_sessions) — VACÍOS y sin escritor en este sprint; el runtime local,
// la sombra y el despachador son F6.5b.

// ── Versión del schema (F6.4b → F6.5a) ──────────────────────────────────────
// CREATE TABLE IF NOT EXISTS no agrega columnas a una DB existente, y el build
// de F6.4a ya creó bodegas en dispositivos reales (TestFlight). Mecanismo:
// sync_meta.schema_version; al abrir, la versión guardada decide el camino
// (connection.js::applySchemaWithMigration).
//
// La sentencia del docstring F6.4b se CUMPLIÓ en F6.5a: la migración-por-
// recreación valía solo mientras la bodega fuera cache puro, y v3 introduce
// el diario local (local_events) — renglones sin subir = irremplazables. Por
// eso v2→v3 es la ÚLTIMA recreación legal (al migrar, todo el contenido v2
// es cache re-descargable y las tablas nuevas aún no existen), y desde v3 la
// recreación queda PROHIBIDA: v4+ migran por la escalera de pasos ALTER de
// connection.js, y un salto sin paso registrado es un fallo contenido y
// ruidoso, JAMÁS un DROP silencioso.
//
// Historial: v1 = F6.4a (implícita, sin key registrada — una bodega sin
// schema_version ES v1 y migra); v2 = F6.4b (documents.material_rev);
// v3 = F6.5a (local_events + local_sessions + documents.chunk_index + llaves
// device_id/last_acked_client_seq — la recreación resuelve sola el backfill
// de chunk_index: bodega fresca → re-descarga con la columna);
// v4 = F6.6a (saved_positions.cleared — la lápida de posición, D-O). Primer
// paso REAL de la escalera ALTER (connection.js::MIGRATION_STEPS[3]);
// v5 = F6.6b Tanda 2a (el EXAMEN local: columnas exam en local_sessions — la
// sesión en vuelo — y el kit de reanudación en exam_sessions — la foto).
// ALTER puro, cero tablas nuevas: ambas tablas existen desde v1/v3;
// v6 = RPW Tanda 3 (exam_sessions.deadline_at — la HORA LÍMITE del examen que
// otro dispositivo tiene en vuelo). Una sola columna: el kit de la foto cambió
// de clientela (de las pausadas a las en-vuelo) y con él su reloj, que dejó de
// ser un restante congelado para ser una hora;
// v7 = RPW Tanda 4 (local_sessions.origin — DE DÓNDE VIENE este examen local).
// Una sola columna, y es el interruptor de todo el carril de D-4c: solo un
// examen ADOPTADO ('web') respalda al servidor lo que se contesta en él y solo
// él acepta la fusión de la foto al entrar. El nacido en el cel la deja NULL y
// sigue 100% local hasta su entrega;
// v8 = F6.8 Tanda C (local_sessions.acta_acked_at — EL ACUSE POR ACTA, INC-3 y
// mecanismo B). Una sola columna. Hasta v7 lo único que el cartero podía dar
// por entregado era un RENGLÓN (local_events.upload_state); un acta que viajaba
// SOLA —un examen entregado sin contestar nada, el cierre de una adaptive cuyos
// renglones ya subieron— no tenía dónde anotar que ya llegó, y por eso no podía
// viajar. Esta columna es esa anotación, y es propiedad de la fila de sesión:
// viaja y muere con ella (la cascada de doc muerto la limpia gratis,
// downloader.js::DELETE FROM local_sessions).
// v9 = F6.8 Tanda 6 (local_sessions.clock_stamped_at — EL INSTANTE DEL SELLO
// DEL RELOJ, T6-2). Una sola columna, y es la mitad que le faltaba al sello: el
// latido guardaba CUÁNTO quedaba y no CUÁNDO lo midió, así que un restante
// sellado no se podía confrontar con nada. Con el instante al lado, reanudar con
// el reloj RETROCEDIDO deja de regalar tiempo: el restante sellado manda como
// techo. Ver `applyClockFloor` (brain/examRuntime.js).
// v10 = F6.8 S-8 (local_sessions.deadline_original_at — LA FECHA HONESTA,
// S8-F1-b). Una sola columna, y es el colateral que la v9 abrió: cuando el piso
// dispara re-ancla `deadline_at` con el `now` de la línea de tiempo ATRASADA, así
// que DESHACER el retroceso equivale a un adelanto contra esa hora límite y el
// examen vence sin haber vencido. Esta columna guarda la hora límite PREVIA al
// primer re-ancla, y con ella la sesión puede SANAR de vuelta a su línea honesta
// en vez de auto-entregarse. Ver `applyDeadlineRescue` (brain/examRuntime.js).
// v11 = F6.8 sprint (c) (local_sessions.apertura_acked_at — EL ACUSE DE LA
// APERTURA). Una sola columna, y es la gemela EXACTA de `acta_acked_at` para el
// otro carril: hasta v10 el cel solo podía dar por entregada una sesión
// TERMINADA, así que la APERTURA de un examen —el hecho de que empezó— no tenía
// dónde anotar su acuse y por eso no podía viajar. Son DOS columnas y no una
// porque son dos carriles distintos sobre la MISMA fila: la apertura viaja
// mientras la sesión está EN VUELO y el acta cuando cierra; un solo sello
// confundiría los dos (sellar la apertura sacaría al acta del carril de
// huérfanas antes de tiempo). Ver `readExamOpenings` (brain/dispatcher.js).
// v12 = TANDA M (M1 + M6) — `documents.locked_at`: EL DOCUMENTO SE CONSERVA
// BLOQUEADO. Una sola columna, y es la que le da al aparato un tercer estado
// que hasta hoy no existía. Antes de v12 una fila de `documents` sólo podía
// estar PRESENTE (servible) o AUSENTE (borrada), así que cuando una bajada de
// plan archivaba un documento y `/sync/state` dejaba de listarlo, el aparato
// leía "lo borraron" y purgaba el material entero — el usuario que volvía a
// pagar tenía que re-descargar todo, y el estudio hecho sobre ese documento se
// quedaba sin su acta y por lo tanto sin forma de llegar al servidor
// (hallazgos #10 y #1 del censo R+S). Con `locked_at` la fila SE QUEDA con todo
// su pool y su historia, sólo que invisible e inusable, y el desbloqueo es
// poner la columna en NULL — cero bytes de red.
// NO se reusa `documents.status`: esa columna es el estado del pool que manda
// el servidor y la que decide si hay material que servir; escribirle 'archived'
// perdería el status previo, que es justo lo que hay que devolver al desbloquear.
//
// DOBLE DEBER (regla de oro de la escalera): cada columna nueva vive en DOS
// lugares — el CREATE de aquí (bodegas FRESCAS, que jamás pasan por la
// escalera) y el paso de connection.js::MIGRATION_STEPS (bodegas EXISTENTES,
// que jamás re-aplican SCHEMA_STATEMENTS). Olvidar un lado produce dos
// poblaciones de dispositivos con schemas distintos; el test de equivalencia
// "fresca vs migrada" (schema.equivalence.test.js) es la red que lo atrapa.
export const WAREHOUSE_SCHEMA_VERSION = 13;

export const CREATE_SYNC_META = `
CREATE TABLE IF NOT EXISTS sync_meta (
  key TEXT PRIMARY KEY,
  value TEXT
);`;

// `locked_at` (v12, TANDA M): instante en que el servidor declaró este
// documento BLOQUEADO (archivado por una bajada de plan). NULL = normal.
// Mientras no sea NULL el documento no se pinta ni se puede estudiar, pero su
// pool, su progreso y sus renglones sin subir se quedan intactos — ver la nota
// de v12 arriba. (El comentario va AQUÍ y no dentro del CREATE: el detector de
// equivalencia fresca-vs-migrada parsea las columnas por línea y no entiende
// comentarios SQL.)
export const CREATE_DOCUMENTS = `
CREATE TABLE IF NOT EXISTS documents (
  id TEXT PRIMARY KEY,
  filename TEXT,
  file_type TEXT,
  status TEXT,
  topics_json TEXT,
  question_count INTEGER,
  flashcard_count INTEGER,
  detected_language TEXT,
  parent_doc_id TEXT,
  created_at TEXT,
  pool_hash TEXT,
  material_rev INTEGER,
  chunk_index INTEGER,
  downloaded_at TEXT NOT NULL,
  locked_at TEXT
);`;

export const CREATE_QUESTIONS = `
CREATE TABLE IF NOT EXISTS questions (
  id TEXT PRIMARY KEY,
  document_id TEXT NOT NULL,
  question_text TEXT,
  topic TEXT,
  difficulty TEXT,
  bloom_level INTEGER,
  options_json TEXT,
  correct_answer INTEGER,
  explanation TEXT,
  rationales_json TEXT
);
CREATE INDEX IF NOT EXISTS idx_questions_document ON questions(document_id);`;

export const CREATE_FLASHCARDS = `
CREATE TABLE IF NOT EXISTS flashcards (
  id TEXT PRIMARY KEY,
  document_id TEXT NOT NULL,
  topic TEXT,
  front TEXT,
  back TEXT
);
CREATE INDEX IF NOT EXISTS idx_flashcards_document ON flashcards(document_id);`;

export const CREATE_FLASHCARD_IMAGES = `
CREATE TABLE IF NOT EXISTS flashcard_images (
  flashcard_id TEXT NOT NULL,
  side TEXT NOT NULL,
  image_data TEXT,
  width_percent REAL,
  PRIMARY KEY (flashcard_id, side)
);`;

export const CREATE_TOPIC_PERFORMANCE = `
CREATE TABLE IF NOT EXISTS topic_performance (
  id TEXT PRIMARY KEY,
  document_id TEXT NOT NULL,
  topic TEXT,
  total_attempts INTEGER,
  correct_attempts INTEGER,
  streak INTEGER,
  ease_factor REAL,
  interval INTEGER,
  bloom_level INTEGER,
  stability REAL,
  last_reviewed TEXT,
  next_review TEXT,
  last_attempted TEXT
);
CREATE INDEX IF NOT EXISTS idx_topic_perf_document ON topic_performance(document_id);`;

// El ORDEN del array original es parte del contrato del motor (fold order,
// censo F6.3). `seq` preserva ese orden exacto tal como llegó en
// mastery_history[doc_id][]. Al leer para alimentar el motor: ORDER BY seq —
// JAMÁS reordenar por timestamp.
export const CREATE_MASTERY_HISTORY = `
CREATE TABLE IF NOT EXISTS mastery_history (
  document_id TEXT NOT NULL,
  seq INTEGER NOT NULL,
  topic TEXT,
  correct INTEGER,
  question_id TEXT,
  selected_answer INTEGER,
  correct_answer INTEGER,
  response_time_ms INTEGER,
  timestamp TEXT,
  PRIMARY KEY (document_id, seq)
);`;

// Ausencia total del doc = el usuario nunca clasificó nada en ese mazo.
export const CREATE_FLASHCARD_PROGRESS = `
CREATE TABLE IF NOT EXISTS flashcard_progress (
  document_id TEXT PRIMARY KEY,
  known_cards_json TEXT,
  updated_at TEXT
);`;

// `cleared` (v4, D-O): la LÁPIDA de posición. Un clear hecho offline se marca
// cleared=1 en vez de borrarse — si se borrara físicamente, la siguiente foto
// del server resucitaría la posición vieja (el clear jamás viajó). La lápida
// vive hasta que un sobre ack'eado la sube (el dispatcher la borra físico) y
// gana/pierde por LWW igual que una posición viva.
export const CREATE_SAVED_POSITIONS = `
CREATE TABLE IF NOT EXISTS saved_positions (
  document_ids_key TEXT PRIMARY KEY,
  current_index INTEGER,
  document_ids_json TEXT,
  ordered_ids_json TEXT,
  updated_at TEXT,
  cleared INTEGER NOT NULL DEFAULT 0,
  sync_attempts INTEGER NOT NULL DEFAULT 0
);`;

// v5 (F6.6b, D-L) / v6 (RPW T3): las últimas son el KIT DE REANUDACIÓN que
// /sync/state baja para las sesiones EN VUELO CON HORA LÍMITE
// (`status == "in_progress"` + `deadline_at`; hasta la RPW T3 eran las
// `paused`). `rng_seeds_json` guarda el mapa {qid: "seed"} COMO TEXTO — el
// `questions_snapshot` completo jamás viaja (26.8 KB de mediana) y los seeds
// web son de 63 bits: como Number JSON los redondearía (D-L#3, asimetría
// firmada en sync_core.py). En reposo se quedan tal como llegaron: texto.
//
// `deadline_at` (v6) es EL RELOJ de esa sesión y su discriminador: sin ella una
// fila `in_progress` es pre-Tanda-1 y nadie la adopta. Sustituye a
// `time_remaining_seconds` como fuente de verdad del tiempo — la columna vieja
// se queda por las filas que ya la tenían escrita (y porque quitarla exigiría
// recrear la tabla, prohibido desde v3).
export const CREATE_EXAM_SESSIONS = `
CREATE TABLE IF NOT EXISTS exam_sessions (
  id TEXT PRIMARY KEY,
  document_ids_json TEXT,
  status TEXT,
  completed INTEGER,
  started_at TEXT,
  completed_at TEXT,
  score REAL,
  correct_count INTEGER,
  total_questions INTEGER,
  time_limit INTEGER,
  results_summary_json TEXT,
  question_ids_json TEXT,
  paused_at TEXT,
  answers_so_far_json TEXT,
  question_times_json TEXT,
  current_index INTEGER,
  time_remaining_seconds REAL,
  rng_seeds_json TEXT,
  deadline_at TEXT
);`;

export const CREATE_STUDY_HISTORY = `
CREATE TABLE IF NOT EXISTS study_history (
  id TEXT PRIMARY KEY,
  mode TEXT,
  document_ids_json TEXT,
  started_at TEXT,
  completed_at TEXT,
  completed INTEGER,
  status TEXT,
  total_answered INTEGER,
  correct_count INTEGER,
  score REAL,
  total_questions INTEGER,
  time_limit INTEGER,
  document_names_json TEXT
);`;

export const CREATE_WATERMARK_DEVICES = `
CREATE TABLE IF NOT EXISTS watermark_devices (
  device_id TEXT PRIMARY KEY,
  max_client_seq INTEGER
);`;

// ── F6.5a: el diario local (v3) — tablas SIN escritor en este sprint ────────
// El runtime de sesión, la sombra y el despachador son F6.5b; aquí solo nace
// la plomería. NADIE escribe local_events/local_sessions en F6.5a (candado de
// sombra D-I: no existe código que suba — censo G.9).

// El diario: un renglón por respuesta/clasificación generada en ESTE
// dispositivo. client_seq es el contador monótono local — la unidad del
// watermark del server y la mitad de la llave de idempotencia
// (device_event_id = uuid5(device:seq), sync_core.py). Columnas espejo
// campo-por-campo del contrato de subida SyncEventIn (backend/models.py,
// censo E.2a) + los builders de sync_core; las estructuras (served_options,
// pre/post_state) viajan como JSON en columnas *_json, convención de la
// bodega. Estado de despacho (diseño F6.5 candado 7b): upload_state
// 'pending' (espera sobre) | 'acked' (el watermark del server lo cubrió) |
// 'rejected_final' (rechazo DEFINITIVO del ingest — jamás se reintenta;
// reject_reason guarda la razón). El índice por upload_state es la query del
// cartero de F6.5b (¿qué renglones van en el próximo sobre?).
export const CREATE_LOCAL_EVENTS = `
CREATE TABLE IF NOT EXISTS local_events (
  client_seq INTEGER PRIMARY KEY,
  event_id TEXT,
  action TEXT,
  client_ts TEXT,
  session_id TEXT,
  seq INTEGER,
  document_id TEXT,
  topic TEXT,
  question_id TEXT,
  flashcard_id TEXT,
  status TEXT,
  selected_answer INTEGER,
  correct_answer INTEGER,
  is_correct INTEGER,
  response_time_ms INTEGER,
  time_spent_seconds INTEGER,
  served_options_json TEXT,
  rng_seed INTEGER,
  pre_state_json TEXT,
  post_state_json TEXT,
  upload_state TEXT NOT NULL DEFAULT 'pending',
  reject_reason TEXT,
  reject_attempts INTEGER NOT NULL DEFAULT 0
);
CREATE INDEX IF NOT EXISTS idx_local_events_upload_state ON local_events(upload_state);`;

// La sesión adaptive EN VUELO: espejo campo-por-campo del doc de
// study_sessions (censo A.2). Razón load-bearing (censo G.11): el turno
// servido (shuffled_questions de la pregunta aún sin contestar) y
// all_question_ids NO son reconstruibles desde el diario — solo viven aquí;
// sin esta tabla, matar la app a media sesión pierde el turno servido y la
// sesión no puede continuar exacta donde iba.
//
// v5 (F6.6b Tanda 2a): la tabla deja de ser solo-adaptive y aloja también el
// EXAMEN en vuelo. Los nombres calcan el doc de study_sessions mode="exam"
// (regla de la cabecera de este archivo), más TRES columnas que solo existen
// en el dispositivo y jamás viajan en el acta:
//   - selection_seed   — el dado del sorteo local. La ruta LOCAL ordena las
//     candidatas por `id` antes de tirarlo, así que seed + orden canónico
//     reproducen el sorteo exacto (la web NO se toca: su `random.sample`
//     sigue saliendo del stream global sobre una lectura de Mongo sin sort).
//   - deadline_at      — D-N: el examen local usa HORA LÍMITE anclada al
//     reloj del device, no cronómetro; por eso el tiempo sigue corriendo en
//     segundo plano, donde un `setInterval` se congela.
//   - backgrounded_at  — el instante en que la app se fue a segundo plano;
//     al volver, el restante se descuenta contra él (D-N T2/T4).
//
// v7 (RPW Tanda 4, D-4c): `origin` — el MARCADOR DE PROCEDENCIA del examen.
// 'web' = esta fila la escribió la ADOPCIÓN (T3-P4): el examen nació en otra
// superficie, sigue vivo en el servidor y por eso este dispositivo es el SEGUNDO
// corredor — respalda lo que contesta y acepta la fusión de la foto al entrar.
// NULL = nació en el cel: 100% local hasta su entrega, y ninguna de las dos
// cosas le pasa. Es el único interruptor del carril, y su valor por defecto
// (NULL) es el comportamiento de siempre.
//
// v8 (F6.8 Tanda C): `acta_acked_at` — EL ACUSE POR ACTA. El instante en que el
// servidor confirmó ESTA acta, o NULL si todavía no. Es la gemela por-sesión de
// `local_events.upload_state = 'acked'`, y existe por la misma razón por la que
// aquélla existe: sin una marca de entregado, lo que viaja re-viaja para
// siempre. Su ausencia es lo que hacía IMPOSIBLE el carril de actas huérfanas
// (INC-3: el examen entregado en blanco no produce ni un renglón donde montar
// el acta; mecanismo B: el cierre de una adaptive tampoco), porque un acta sin
// renglón no tenía dónde anotar su propio acuse.
//
// v9 (F6.8 Tanda 6, T6-2): `clock_stamped_at` — EL INSTANTE DEL SELLO DEL
// RELOJ. Es la mitad que le faltaba a `time_remaining_seconds`: el latido
// guardaba CUÁNTO quedaba y no CUÁNDO lo midió, así que un restante sellado no
// se podía confrontar con nada. Juntos son un par {restante, instante} que
// permite ATAJAR EL RETROCESO: si al reanudar el reloj marca ANTES que el último
// sello, la única lectura honesta es que la hora del dispositivo se movió hacia
// atrás, y el restante sellado manda como TECHO (atrasar el reloj no regala
// tiempo). Con el reloj honesto no cambia un solo número.
//
// v10 (F6.8 S-8, S8-F1-b): `deadline_original_at` — LA FECHA HONESTA. La hora
// límite que la sesión tenía ANTES de que el piso la re-anclara por primera vez.
// Nace del colateral que la v9 destapó: el piso re-ancla contra el `now` de la
// línea de tiempo ATRASADA, así que la hora límite queda viviendo allá y
// restaurar el reloj se lee como un adelanto — el examen vence sin haber vencido,
// y basta abrir el Dashboard para que se auto-entregue. Con la hora previa
// guardada, las puertas que declaran vencido pueden SANAR la sesión de vuelta a
// su línea honesta en vez de entregarla. Se escribe UNA vez (retrocesos
// encadenados no la pisan) y se limpia a NULL al sanar.
//
// v11 (F6.8 sprint c): `apertura_acked_at` — EL ACUSE DE LA APERTURA. El
// instante en que el servidor confirmó que este examen EMPEZÓ, o NULL si
// todavía no. Es la gemela de `acta_acked_at` (v8) sobre el otro carril de la
// misma fila, y existe por la misma razón: sin una marca de entregado, lo que
// viaja re-viaja para siempre. Dos columnas y no una porque los dos carriles
// conviven en el tiempo — la apertura viaja mientras la sesión está EN VUELO y
// el acta cuando cierra— y un sello compartido sacaría al acta del carril de
// huérfanas antes de tiempo (`readOrphanActas` frena con `acta_acked_at`).
//
// Nullable y sin DEFAULT, como todas las columnas nuevas desde v4: un ALTER ADD
// COLUMN nullable no reescribe filas en SQLite. Las filas que ya existían la
// leen como NULL — o sea, "esta acta todavía no la confirma nadie" (v8), "este
// restante no trae instante" (v9), "a esta sesión nunca le movieron la hora
// límite" (v10) y "esta apertura todavía no la confirma nadie" (v11), que en
// los cuatro casos es la verdad para todas ellas y en los cuatro casos degrada
// al comportamiento de siempre.
export const CREATE_LOCAL_SESSIONS = `
CREATE TABLE IF NOT EXISTS local_sessions (
  id TEXT PRIMARY KEY,
  mode TEXT,
  document_ids_json TEXT,
  all_question_ids_json TEXT,
  asked_question_ids_json TEXT,
  topic_history_json TEXT,
  correct_count INTEGER,
  total_answered INTEGER,
  started_at TEXT,
  last_activity_at TEXT,
  completed INTEGER,
  status TEXT,
  shuffled_questions_json TEXT,
  completed_at TEXT,
  abandoned_at TEXT,
  questions_at_abandon INTEGER,
  question_ids_json TEXT,
  questions_snapshot_json TEXT,
  answers_so_far_json TEXT,
  question_times_json TEXT,
  current_index INTEGER,
  time_limit INTEGER,
  total_questions INTEGER,
  score REAL,
  results_summary_json TEXT,
  selection_seed INTEGER,
  deadline_at TEXT,
  time_remaining_seconds REAL,
  paused_at TEXT,
  backgrounded_at TEXT,
  origin TEXT,
  acta_acked_at TEXT,
  clock_stamped_at TEXT,
  deadline_original_at TEXT,
  apertura_acked_at TEXT,
  sync_attempts INTEGER NOT NULL DEFAULT 0
);`;

// Lista canónica de tablas — ÚNICA fuente para el schema combinado y para el
// DELETE total del purge (una tabla nueva se agrega aquí y queda cubierta en
// ambos lados automáticamente).
export const WAREHOUSE_TABLES = [
  'sync_meta',
  'documents',
  'questions',
  'flashcards',
  'flashcard_images',
  'topic_performance',
  'mastery_history',
  'flashcard_progress',
  'saved_positions',
  'exam_sessions',
  'study_history',
  'watermark_devices',
  // F6.5a (v3): el diario y la sesión en vuelo entran a la lista canónica →
  // purge y drop las cubren POR DERIVACIÓN (candado D-J: la purga por
  // identidad destruye el diario y con él muere el remitente).
  'local_events',
  'local_sessions',
];

export const SCHEMA_STATEMENTS = [
  CREATE_SYNC_META,
  CREATE_DOCUMENTS,
  CREATE_QUESTIONS,
  CREATE_FLASHCARDS,
  CREATE_FLASHCARD_IMAGES,
  CREATE_TOPIC_PERFORMANCE,
  CREATE_MASTERY_HISTORY,
  CREATE_FLASHCARD_PROGRESS,
  CREATE_SAVED_POSITIONS,
  CREATE_EXAM_SESSIONS,
  CREATE_STUDY_HISTORY,
  CREATE_WATERMARK_DEVICES,
  CREATE_LOCAL_EVENTS,
  CREATE_LOCAL_SESSIONS,
].join('\n');

// "Purga TODO" (identity.js): las filas de TODAS las tablas en una sola
// transacción — todo-o-nada bajo WAL.
export const PURGE_ALL_ROWS_STATEMENTS = WAREHOUSE_TABLES
  .map((table) => `DELETE FROM ${table};`)
  .join('\n');

// Migración-por-recreación (ver WAREHOUSE_SCHEMA_VERSION): tirar TODAS las
// tablas para recrearlas con el schema vigente.
export const DROP_ALL_TABLES_STATEMENTS = WAREHOUSE_TABLES
  .map((table) => `DROP TABLE IF EXISTS ${table};`)
  .join('\n');

// Llaves reservadas de sync_meta.
export const SYNC_META_KEYS = {
  OWNER_USER_ID: 'owner_user_id',
  SERVER_TIME: 'server_time',
  LAST_SYNCED_AT: 'last_synced_at',
  WAREHOUSE_EPOCH: 'warehouse_epoch',
  SCHEMA_VERSION: 'schema_version',
  // Última foto conocida de {planInfo, usage} del Dashboard (F6.4b §5,
  // decisión firmada: opción A) — write-through en cada fetch vivo exitoso.
  PLAN_SNAPSHOT: 'plan_snapshot',
  // Snapshot mínimo del user (el objeto de /auth/me) escrito en cada sesión
  // autenticada nativa — de aquí sale el `user` del boot offline (F6.4b §4),
  // y desde F6.7b también el TIER local del candado D-G (cero storage nuevo:
  // el plan ya viaja dentro de este mismo objeto).
  USER_SNAPSHOT: 'user_snapshot',
  // F6.7b — LA FOTO LOCAL DE LA LISTA del Panel: la última lista de documentos
  // que se leyó CON SEÑAL, ligera (solo los campos que la tarjeta pinta). Sin
  // señal el Panel pinta esta foto, así las tarjetas sobreviven a un kill de la
  // app sin red — el screenDataCache de F4.3b es memoria pura y muere con el
  // proceso (screenDataCache.js:19). Es verdad de SERVIDOR congelada, no
  // inventario del teléfono: incluye docs `processing`, que jamás entran a la
  // bodega. Va en sync_meta como sus hermanas plan_snapshot/user_snapshot —
  // tabla existente, cero migración.
  DOCS_SNAPSHOT: 'docs_snapshot',
  // F6.8 T4 (D-F8-2b) — LOS TRES TOTALES DEL OVERVIEW, precocinados por el
  // servidor: `{total_documents, total_sessions, total_questions_answered}`,
  // shape PLANO. La escribe el DESCARGADOR con la foto de `/sync/state` y la lee
  // `overviewTotalsFromSnapshot` (brain/analyticsReads.js), que ya existía
  // esperándola: con llave manda la foto (+ el incremento local de las sesiones
  // que aún no viajan), sin llave se deriva de bodega con sus desvíos H9/H10.
  //
  // SIN CADUCIDAD (D-2), y no le hace falta: se reescribe en CADA foto, así que
  // su edad ES la edad de la foto. Una llave con fecha propia solo podría
  // desalinearse de las tablas que la acompañan.
  //
  // Y POR ESO SE ESCRIBE EN LA MISMA TRANSACCIÓN QUE LA FOTO (restricción dura
  // G-2, escrita en la doctrina del lector). El incremento local suma las
  // sesiones completadas que la foto NO trae; si el snapshot se committeara
  // aparte, entre las dos transacciones el número saldría doble (snapshot nuevo
  // + tablas viejas: la sesión cuenta en los dos) o en cero. `buildPhotoSet`
  // (downloader.js) la emite como un statement más de su propio set, y
  // downloader.overviewSnapshot.test.js fija estructuralmente que sea el MISMO.
  OVERVIEW_SNAPSHOT: 'overview_snapshot',
  // t7-3 (A1 y A3, #557 y #558): LA FOTO DE LOS GRUPOS DEL ALUMNO: la ultima respuesta
  // de `GET /grupos/alumno/material` que llego CON RED. Sin red el Panel pinta la tarjeta
  // del grupo desde aqui, y el cartero decide con ella que cards bajar, bloquear o borrar
  // (lib/warehouse/cardsDelGrupo.js). Hermana de docs_snapshot: tabla existente, cero
  // migracion; sin la llave, ni el Panel ni el cartero tocan una sola card.
  GRUPOS_SNAPSHOT: 'grupos_snapshot',
  // F6.5a (v3) — llaves RESERVADAS, escritas por F6.5b (aquí nadie escribe):
  // el remitente del dispositivo (D-J: nace y muere con la bodega — la purga
  // por identidad lo destruye junto con el contador, así jamás llega
  // "renglón 1" repetido bajo un remitente viejo)…
  DEVICE_ID: 'device_id',
  // …y el último client_seq confirmado por el ack del server (el watermark
  // local: desde dónde reanudar la subida).
  LAST_ACKED_CLIENT_SEQ: 'last_acked_client_seq',
  // F6.6a (D-O) — la MARCA DE AGUA del carril de posiciones: el `saved_at`
  // más nuevo entre las posiciones que viajaron en un sobre ACKEADO. Hermana
  // de LAST_ACKED_CLIENT_SEQ y load-bearing por DOS razones simétricas:
  //   (subida) una fila que el server ya conoce deja de re-enviarse — si
  //     siguiera viajando, resucitaría en el server una posición que la web
  //     acaba de borrar (Reset / Start Fresh / Study still learning hacen
  //     delete server-side, y el LWW no puede distinguir "nunca la viste" de
  //     "la borraste": sin marca, el device deshace el borrado del usuario);
  //   (bajada) su ausencia en la foto solo significa "el server la borró"
  //     para filas por DEBAJO de la marca; las de arriba están pendientes de
  //     subir y JAMÁS se barren (así un corte de red no pierde una posición
  //     guardada offline).
  // Ausente (bodega migrada o recién purgada) = nada confirmado: todo viaja y
  // nada se barre — el default conservador.
  LAST_ACKED_POSITION_AT: 'last_acked_position_at',
  // ── RPW T3 — AQUÍ VIVÍAN LAS TRES LLAVES DE LA MAQUINARIA DE PAUSAS ────
  // `EXAM_DISCARD_TOMBSTONES` (las lápidas del "Empezar de cero", para que la
  // foto no resucitara una pausa descartada), `EXAM_DISCARD_DELETE_QUEUE` (los
  // DELETE que no habían podido viajar) y `EXAM_PAUSE_REJECTED` (las actas que
  // el ingest rechazó con defecto, para que no fueran spam eterno).
  //
  // Se retiran las tres al jubilarse la maquinaria. NO se borran de las bodegas
  // existentes y eso es deliberado: son filas de `sync_meta` de unos cuantos
  // bytes que nadie vuelve a leer ni a escribir, y un DELETE tendría que vivir
  // en la escalera de migración —una escritura de riesgo sobre la tabla que
  // guarda la identidad y el contador del remitente— a cambio de nada.
  // F6.5b — el ASIGNADOR monótono de client_seq (el contador del remitente,
  // D-J). Vive aquí y JAMÁS se deriva de MAX(local_events.client_seq): los
  // renglones rejected_final se barren con el pool de su doc, y un MAX que
  // retrocede re-emitiría seqs ya usados bajo el mismo remitente — el
  // event_id determinista uuid5(device:seq) los colapsaría como duplicados
  // y el estudio se perdería en silencio. Muere con la purga por
  // construcción (misma vida que DEVICE_ID).
  LAST_CLIENT_SEQ: 'last_client_seq',
};
